import React from 'react';
import PropTypes from 'prop-types';
import { ActivationContextProvider } from './Activation';
import { CustomerContextProvider } from './Customer';
import { DocumentContextProvider } from './Document';
import { LookUpContextProvider } from './LookUp';

export function MobileOneProvider({ children, config, env }) {
  return (
    <>
      {/* Customer Context Provider */}
      <CustomerContextProvider {...{ config: { ...config, env } }}>
        {/* Sim Activation Context Provider */}
        <ActivationContextProvider {...{ config: { ...config, env } }}>
          {/* Lookup Context Provider */}
          <LookUpContextProvider {...{ config: { ...config, env } }}>
            {/* Document Context Provider */}
            <DocumentContextProvider {...{ config: { ...config, env } }}>
              {children}
            </DocumentContextProvider>
          </LookUpContextProvider>
        </ActivationContextProvider>
      </CustomerContextProvider>
    </>
  );
}

MobileOneProvider.propTypes = {
  children: PropTypes.node.isRequired
};

export default MobileOneProvider;
